import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import SelectReportsIcon from '@common/components/icons/SelectReportsIcon';
import ChevronIcon from '@common/components/icons/ChevronIcon';
import MultiSelectList from '@common/components/MultiSelectList';
import * as styles from '../ScheduleReportPage.module.css';

/**
 * SelectReportsSection Component
 * 
 * Section for selecting saved reports to schedule
 */
function SelectReportsSection({
  expanded,
  onToggle,
  savedReports,
  selectedSavedReports,
  onSelectionChange,
  loading,
}) {
  const { t } = useTranslation();

  return (
    <div className={styles.section}>
      <button
        type="button"
        className={styles.sectionHeader}
        onClick={onToggle}
      >
        <div className={styles.sectionTitleWrapper}>
          <SelectReportsIcon className={styles.sectionIcon} />
          <div className={styles.sectionTitleContent}>
            <span className={styles.sectionTitle}>
              {t('scheduledReports.sections.selectReports.title')}
            </span>
            <span className={styles.sectionSubtitle}>
              {t('scheduledReports.sections.selectReports.subtitle')}
            </span>
          </div>
        </div>
        <ChevronIcon className={expanded ? styles.chevronExpanded : styles.chevron} />
      </button>

      {expanded && (
        <div className={styles.sectionContent}>
          <MultiSelectList
            id="report-search"
            label={t('scheduledReports.sections.selectReports.label')}
            items={savedReports}
            selectedIds={selectedSavedReports}
            onSelectionChange={onSelectionChange}
            searchPlaceholder={t('scheduledReports.sections.selectReports.searchPlaceholder')}
            labelKey="name"
            descriptionKey="description"
            idKey="id"
            loading={loading}
            emptyMessage={t('savedReports.noSavedReports')}
            showChips
          />
        </div>
      )}
    </div>
  );
}

SelectReportsSection.propTypes = {
  expanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  savedReports: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    description: PropTypes.string,
  })).isRequired,
  selectedSavedReports: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  onSelectionChange: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

SelectReportsSection.defaultProps = {
  loading: false,
};

export default SelectReportsSection;

